/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReprocessCreditApplication_reprocessCreditApplication_Status = { readonly __typename: 'Status', readonly message: string | null };

export type ReprocessCreditApplication_Mutation = { readonly __typename: 'Mutation', readonly reprocessCreditApplication: ReprocessCreditApplication_reprocessCreditApplication_Status | null };


export type ReprocessCreditApplicationVariables = _Types.Exact<{
  salesforceCreditId: _Types.Scalars['String']['input'];
  reason: _Types.Scalars['String']['input'];
}>;


export type ReprocessCreditApplication = ReprocessCreditApplication_Mutation;


export const ReprocessCreditApplicationDocument = gql`
    mutation ReprocessCreditApplication($salesforceCreditId: String!, $reason: String!) {
  reprocessCreditApplication(
    salesforceCreditId: $salesforceCreditId
    reason: $reason
  ) {
    message
  }
}
    `;
export type ReprocessCreditApplicationMutationFn = Apollo.MutationFunction<ReprocessCreditApplication, ReprocessCreditApplicationVariables>;

/**
 * __useReprocessCreditApplication__
 *
 * To run a mutation, you first call `useReprocessCreditApplication` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReprocessCreditApplication` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reprocessCreditApplication, { data, loading, error }] = useReprocessCreditApplication({
 *   variables: {
 *      salesforceCreditId: // value for 'salesforceCreditId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useReprocessCreditApplication(baseOptions?: Apollo.MutationHookOptions<ReprocessCreditApplication, ReprocessCreditApplicationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReprocessCreditApplication, ReprocessCreditApplicationVariables>(ReprocessCreditApplicationDocument, options);
      }
export type ReprocessCreditApplicationHookResult = ReturnType<typeof useReprocessCreditApplication>;
export type ReprocessCreditApplicationMutationResult = Apollo.MutationResult<ReprocessCreditApplication>;
export type ReprocessCreditApplicationMutationOptions = Apollo.BaseMutationOptions<ReprocessCreditApplication, ReprocessCreditApplicationVariables>;